import { callApiToServer } from '../callApi';

export async function addLanguage(
  authtoken,
  language
) {
  try{
    let header = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      "authorization" : "Berear " + authtoken
    };
      
    let body = JSON.stringify({
        name : language.name
    });
  
    let endUrl = "v1/auth/admin/add-language";
  
    let responseData = await callApiToServer(body, header, "POST", endUrl);
    return responseData;
      
  }catch(err) {
    throw err;
  }
}
